export const CATEGORIES = {
    FOCUS: 'focus',
    STYLE: 'style',
    COLOR: 'color',
    LIGHTING: 'lighting',
    EMOTION: 'emotion',
};
